import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from '@angular/router';
import { LocationStrategy } from "@angular/common";
/**
 * Welcome Wallet Modal Component
 */
let WelcomeWalletModalComponent = class WelcomeWalletModalComponent {
    constructor(sanitizer, router, location, themeService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    closeAndGoToHome() {
        this.modal.destroy();
        this.router.navigateByUrl('');
    }
    goToVerification() {
        this.modal.destroy();
        this.router.navigateByUrl('verify');
    }
    goToMFA() {
        this.modal.destroy();
        this.router.navigateByUrl('account/authentication');
    }
};
WelcomeWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService }
];
WelcomeWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-welcome-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./welcome-wallet-modal.component.html")).default
    })
], WelcomeWalletModalComponent);
export { WelcomeWalletModalComponent };
